import { UseQueryOptions, useQuery } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { VisualElement, VisualElementsClient } from 'api/clients/VisualElementClient'
import { useRootStore } from 'stores/RootStore'

interface Props {
  id: number
}

type Data = VisualElement

const fetchVisualElement = async (id: number) => {
  const res = await VisualElementsClient.getElement(id)

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error()
  }

  return res.data
}

export const useVisualElement = ({ id }: Props, options?: Partial<UseQueryOptions<Data>>) => {
  const { visualElements } = useRootStore()

  return useQuery<Data>(['visualElements', id], () => fetchVisualElement(id), {
    initialData: () => visualElements.getElement(id),
    ...options,
  })
}
